import { ulid } from "ulid";
import RightArrowExtendedIconSVG from "../../../SharedComponents/assets/icons/svg/RightArrowExtendedIconSVG";
import BaseButton from "../../../SharedComponents/components/Buttons/BaseButton";
import BaseModal from "../../../SharedComponents/components/Modals/BaseModal";
import { ButtonVariantEnum } from "../../../SharedComponents/utils/enums/ButtonVariantEnum";
import { FontEnum } from "../../../SharedComponents/utils/enums/FontEnum";
import { parsePartStateIntegerValue } from "../../utils/formHelpers/parsePartStateIntegerValue";
import { useDispatch } from "react-redux";
import { createRequest } from "../../reduxStore/entities/partRequest";
import { getSrcUrlFromFile } from "../../../SharedComponents/utils/helpers/getSrcUrlFromFile";

const ConfirmOrderPartModal = ({
    open,
    setOpen,
    getValues,
    selectedCar,
    selectedImages,
    address,

}) => {
    const dispatch = useDispatch();
    const values = getValues();
    const part_req_ulid = ulid();
    const part_state = parsePartStateIntegerValue(values.isWantingNewPart, values.isWantingUsedPart);
    const imageUris = selectedImages || [];

    const handleSubmit = async () => {
        let formData = new FormData();

        formData.append('id_car_make', +selectedCar.id_car_make);
        formData.append('id_car_model', +selectedCar.id_car_model);
        formData.append('id_car_generation', +selectedCar.id_car_generation);
        formData.append('address_id', address);
        formData.append('ulid', part_req_ulid);
        formData.append('partstate', +part_state);

        if (selectedCar.id_car_motor) {
            formData.append('id_car_motor', +selectedCar.id_car_motor);
        };

        if (!!selectedCar.vin) {
            formData.append('vin', selectedCar.vin);
        };

        formData.append('description', values.partDescription);

        selectedImages.forEach((image) => {
            formData.append("images", image);
        });

        dispatch(createRequest(formData));
        setOpen(false);
    };


    const GetSelectedCarDiv = () => {
        const getCarInfoDivString = () => {
            return `${selectedCar.Model.name} • ${selectedCar.Motor.name} • ${selectedCar.Generation.name} • ${selectedCar.vin}`;
        };

        return (
            <div style={styles.selectedItemContainer}>
                <img
                    src={getSrcUrlFromFile(selectedCar.UserCarImages[0])}
                    style={styles.carImage}
                />
                <div>
                    <p style={styles.carNameText}>
                        {selectedCar.title}
                    </p>

                    <p style={styles.carDescriptionText}>
                        {getCarInfoDivString(selectedCar)}
                    </p>
                </div>
            </div>
        );
    };

    const GetInputedRequest = () => {
        const { partDescrtiption, detailedPartDescription } = values;

        const getRequestTitle = () => {
            return `Zahtev: ${partDescrtiption}`;
        };

        return (
            <div style={styles.selectedItemContainer}>
                <div style={styles.imageComponent}>
                    <img
                        src={getSrcUrlFromFile(selectedImages[0])}
                        style={styles.carImage}
                    />
                </div>
                <div>
                    <p style={styles.carNameText}>
                        {getRequestTitle()}
                    </p>

                    {detailedPartDescription && (
                        <p style={{ ...styles.carDescriptionText, overflowWrap: 'break-word' }}>
                            {detailedPartDescription}
                        </p>
                    )}
                </div>
            </div>
        );
    };


    return (
        <BaseModal
            open={open}
            setOpen={setOpen}
            externalStyle={styles.externalModalStyle}
        >
            <div style={styles.topLevelContainer}>
                <div>
                    <div style={styles.mainContainer}>
                        <p style={styles.title}>
                            Postavljanje zahteva
                        </p>
                    </div>

                    <div style={styles.itemsContainer}>
                        {GetSelectedCarDiv()}

                        {GetInputedRequest()}
                    </div>
                </div>

                <div style={styles.modalFooterContariner}>
                    <div style={styles.modalFooterContarinerUpperRow}>
                        <div
                            onClick={() => setOpen(false)}
                            style={styles.clickable}
                        >
                            <p style={styles.backTitle}>
                                Nazad
                            </p>
                        </div>

                        <BaseButton
                            onClick={handleSubmit}
                            variant={ButtonVariantEnum.BLACK}
                            text={"Postavi zahtev"}
                            IconComponent={RightArrowExtendedIconSVG}
                        />
                    </div>

                    <p style={styles.footerInfoText}>
                        U sledecih 24h ce ti stizati ponude
                    </p>

                </div>
            </div>

        </BaseModal>
    );
};

export default ConfirmOrderPartModal;

const styles = {
    topLevelContainer: {
        height: "100%",
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: 40
    },
    mainContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 40
    },
    title: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 400,
        fontSize: "34px",
        color: "#000000de"
    },
    externalModalStyle: {
        minHeight: "614px",
        width: "821px",
    },
    selectedItemContainer: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        border: "1px solid #0000003b",
        borderRadius: 8,
        paddingInline: 12,
        paddingTop: 10,
        paddingBottom: 10,
        backgroundColor: "#F3F4F6",
    },
    imageComponent: {
        display: 'flex'
    },
    clickable: {
        cursor: "pointer"
    },
    carImage: {
        width: "48px",
        height: "48px",
        border: "1px solid #0000003b",
        borderRadius: 8,
        objectFit: "cover"
    },
    carNameText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "20px",
        fontWeight: 600,
        color: "#000000"
    },
    carDescriptionText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        fontWeight: 400,
        color: "#000000de",
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        overflowWrap: 'break-word'
    },
    itemsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 20
    },
    backTitle: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 400,
        fontSize: "20px",
        color: "#5B21B6"
    },
    modalFooterContariner: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10
    },
    modalFooterContarinerUpperRow: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 20
    },
    footerInfoText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 400,
        fontSize: "16px",
        color: "#000000de"
    }
};